import { defineStore } from "pinia";
import { computed, Ref } from "vue";
import { useLocalStorage } from "@vueuse/core";
import {
  initPromiseContents,
  initStateContents,
  PromiseContentsType,
  StateContentsType,
} from "stores/ParentSessionContentsConst";
import { date } from "quasar";

export const useParentSessionStore = defineStore("promiseContents", () => {
  const promiseContents: Ref<PromiseContentsType> = useLocalStorage(
    `forme_b2c_${process.env.VUE_APP_ENV}/promiseContents`,
    initPromiseContents
  );

  const getPromiseContents = computed((): PromiseContentsType => {
    return promiseContents.value;
  });

  function setPromiseContents(prefix: string, index: number) {
    const content = promiseContents.value[prefix][index];
    if (!content) return;
    content.isRead = true;
    if (!content.readDt) {
      content.readDt = date.formatDate(new Date(), "YYYY-MM-DD");
    }
  }

  function resetPromiseContents() {
    promiseContents.value = initPromiseContents;
  }

  const stateContents: Ref<StateContentsType> = useLocalStorage(
    `forme_b2c_${process.env.VUE_APP_ENV}/stateContents`,
    initStateContents
  );

  const getStateContents = computed((): StateContentsType => {
    return stateContents.value;
  });

  function setStateContents(name: string, index: number) {
    const content = stateContents.value[name][index];
    if (!content) return;
    content.isRead = true;
    if (!content.readDt) {
      content.readDt = date.formatDate(new Date(), "YYYY-MM-DD");
    }
  }

  return {
    promiseContents,
    getPromiseContents,
    setPromiseContents,
    stateContents,
    getStateContents,
    setStateContents,
    resetPromiseContents,
  };
});
